import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import ControlledButton from 'typescript/components/forms/controlled_button';
import {
  isOrderFree,
  orderRequiresCardOnFile,
} from 'typescript/utilities/order_data';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';
import { useGetOrderSummary } from 'typescript/hooks/use_order_actions_client';

interface DeliveryPageCTAProps extends HTMLAttributes<HTMLElement> {
  control: Control;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
}

const DeliveryPageCTA = ({
  className,
  control,
  disabled = false,
  isLoading = false,
  onClick,
}: DeliveryPageCTAProps) => {
  const { t } = useTranslation();
  const { orderNumber } = useCheckoutFlow();
  const { orderSummaryData } = useGetOrderSummary({ orderNumber });

  const completesOnDeliveryPage =
    isOrderFree(orderSummaryData?.payment_due) &&
    !orderRequiresCardOnFile(orderSummaryData);

  const buttonLabel = completesOnDeliveryPage
    ? t('checkout.delivery.cta.completeOrder')
    : t('checkout.delivery.cta.continueToPayment');

  return (
    <ControlledButton
      className={className}
      control={control}
      name="submit"
      disabled={disabled}
      isLoading={isLoading}
      onClick={onClick}
      label={buttonLabel}
    />
  );
};

export default DeliveryPageCTA;
